import { hasPermission } from '../utils';
export var HasPermission = function (_a) {
    var seraphimPermission = _a.seraphimPermission, seraphimMode = _a.seraphimMode, children = _a.children;
    return hasPermission(seraphimPermission, seraphimMode) ? children : null;
};
